<template>
  <span class="rf-icon" aria-hidden="true">
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.5 2.45a3.75 3.75 0 0 1 3.75 3.75v3h-7.5v-3a3.75 3.75 0 0 1 3.75-3.75zm-6 3.75v3H0v15h21v-15h-4.5v-3a6 6 0 1 0-12 0zm-2.25 5.25h16.5v10.5H2.25v-10.5zm9.38 3.75v-1.13H9.37v5.26h2.26V15.2z"
        fill="inherit"
        stroke="none"
      />
    </svg>
  </span>
</template>
